var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeInVisible(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 3.75L19.5 20.25",
    stroke: "#1A1A1D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5223 14.7742C13.7864 15.4431 12.8149 15.7923 11.8215 15.745C10.8281 15.6976 9.89422 15.2576 9.22524 14.5217C8.55626 13.7858 8.20698 12.8144 8.25424 11.821C8.3015 10.8276 8.74142 9.89366 9.47724 9.22461",
    stroke: "#1A1A1D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.93698 6.43164C3.11486 8.36716 1.5 12.001 1.5 12.001C1.5 12.001 4.5 18.7503 12 18.7503C13.7572 18.7643 15.4926 18.3595 17.0623 17.5695",
    stroke: "#1A1A1D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5586 15.8538C21.6025 14.0231 22.5015 12.0007 22.5015 12.0007C22.5015 12.0007 19.5015 5.25002 12.0015 5.25002C11.3519 5.24895 10.7033 5.30176 10.0625 5.4079",
    stroke: "#1A1A1D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.707 8.31641C13.5041 8.46945 14.23 8.8768 14.7759 9.47734C15.3219 10.0779 15.6584 10.8392 15.735 11.6472",
    stroke: "#1A1A1D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeInVisible);
export default __webpack_public_path__ + "static/media/eyeInVisible.c63fdc5cfcfdb85c3c21697d51fb1a17.svg";
export { ForwardRef as ReactComponent };